// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Messages_wrap_1GK3O","modal":"Messages_modal_1DSDF"};